import { z } from 'zod';

/**
 * The kind of actor making a request to a Fragment API.
 *
 * - `human`           Dashboard user (Auth0). Identified by Auth0 `sub`; also
 *                    represented as a `User` document in the Global table.
 * - `service`         Fragment-internal service (e.g. Global API calling
 *                    Internal API). Identified by Auth0 `sub`.
 * - `customer_api_client` Customer-facing API client (Cognito). Identified by
 *                    Cognito `sub`; also lives as an `ApiClient` doc in the
 *                    Workspaces table.
 *
 * See the Permissions RFC for context.
 */
export const PrincipalTypeSchema = z.enum([
  'human',
  'service',
  'customer_api_client',
]);

export type PrincipalType = z.infer<typeof PrincipalTypeSchema>;

export const principalTypes = PrincipalTypeSchema.options;
